var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":'https://i.lsc-wx.co/profiles/' + _vm.userId + '.png'},on:{"error":_vm.imageUrlAlt}})}
var staticRenderFns = []

export { render, staticRenderFns }